import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerFetchTxnListApiCallSuccess } from 'redux/actions';
import { TRIGGER_FETCH_TXN_LIST_API } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerFetchTxnListApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const PAGE_NUM = data['pageNum'];
	const PAGE_SIZE = data['pageSize'];
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url:
			API_CONSTANT.URL.FILTERED_TXN_LIST +
			API_CONSTANT.QUERY_PARAMS.PAGE_NUM +
			PAGE_NUM +
			API_CONSTANT.QUERY_PARAMS.PAGE_SIZE +
			PAGE_SIZE,
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
		},
		loaderDetails: {
			first_message: 'fetching your',
			start_index: 0,
			range: 9,
			second_message: 'transactions',
		},
	});
	if (api && api.data) {
		const apiData = api.data?.account_statement;
		apiData['dontAppend'] = data['dontAppend'];
		callback && callback(apiData);
		yield put(triggerFetchTxnListApiCallSuccess(apiData, apiData?.statement_details));
	}
}

export default function* triggerFetchTxnListApiCallSaga() {
	yield takeEvery(TRIGGER_FETCH_TXN_LIST_API, triggerFetchTxnListApiCall);
}
